import axios from "axios";
import DefaultGetConfig from "../../../utils/defaultGetConfig";

const loadAutomotorData = async (authObj) => {
    let marcasConfig = DefaultGetConfig(authObj)
    let urlMarcas = process.env.REACT_APP_BACK_SERVER + '/getMarcasAutos';
    const requestMarcas = axios.get(urlMarcas, marcasConfig);

    let urlCoberturas = process.env.REACT_APP_QUOTATION_MICROSERVICE + '/detallesCoberturas/autos'
    const requestCoberturas = axios.get(urlCoberturas);

    try {
        const [marcas, coberturasData] = await axios.all([requestMarcas, requestCoberturas])

        const frequent = [];
        const rest = [];

        if (typeof marcas.data === "object" && marcas.data.length > 0) {
            marcas.data.forEach((marca, idx) => {
                if (idx < 10) {
                    frequent.push({...marca, group: 'Frecuentes'})
                } else {
                    rest.push({...marca, group: 'Todas' })
                }
            })
        }

        const formattedMarcas = [...frequent, ...rest];

        return {
            marcas: formattedMarcas,
            coberturas: coberturasData.data
        };
    } catch (error) {
        console.error('Error loading automotor data:', error);
        throw error;
    }
};

export default loadAutomotorData;
